import { useTranslation } from "react-i18next";
import cls from "./invite-friend.module.scss";
import Link from "next/link";

export default function InviteFriend() {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <Link href="/referrals" className={cls.text}>
        {t("Invite a friend and get money in to your wallet")}
      </Link>
    </div>
  );
}
